<template>
  <b-input
    class="form-control"
    :name="name"
    :id="id"
    v-model="internalMaskValue"
    v-mask="mask"
    :placeholder="placeholder"
    :state="computedState"
    style="max-width: 5em;"
     />
</template>

<script>
import moment from 'moment'
import { getMaskForMomentFormat, adjustMask } from '../utils/mask'

export default {
  data () {
    return {
      internalMaskValue: this.value || this.defaultValue || ''
    }
  },
  props: {
    value: String,
    format: {
      type: String,
      default: 'HH:mm'
    },
    parseStrict: Boolean,
    placeholder: {
      type: String,
      default (val) { return this.$gettext('hh:mm') }
    },
    defaultValue: String,
    name: String,
    id: String,
    state: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    mask () { return { mask: getMaskForMomentFormat(this.format) } },
    computedState () {
      const inp = this.internalMaskValue
      if (inp === '' || inp === null || this.isValid(inp)) return this.state
      return false
    }
  },
  methods: {
    isValid (inp) {
      const format = this.format
      return moment(adjustMask(inp), format, this.parseStrict).isValid()
    },
    initValues (val) {
      if (!val) this.internalMaskValue = this.defaultValue || ''
      else if (val !== this.internalMaskValue) this.internalMaskValue = val
    }
  },
  watch: {
    value (val) {
      this.initValues(val)
    },
    internalMaskValue (val) {
      const adjustedValue = adjustMask(val)
      if (adjustedValue !== this.value && this.isValid(val)) {
        this.$emit('input', adjustedValue)
        this.$emit('change', adjustedValue)
      }
    },
    defaultValue (val) {
      this.internalMaskValue = this.internalMaskValue ? this.internalMaskValue : (val || this.internalMaskValue)
    }
  },
  mounted () {
    this.initValues(this.value)
  }
}
</script>
